import { useState, useEffect } from 'react'
import { mediaApi, type MediaFile } from '../utils/api'
import MediaManager from '../components/MediaManager'

export default function Media() {
  const [files, setFiles] = useState<MediaFile[]>([])
  const [loading, setLoading] = useState(true)

  async function loadFiles() {
    setLoading(true)
    try {
      const data = await mediaApi.list()
      console.log('API Response:', data)
      setFiles(data.files)
    } catch (err) {
      console.error('Fetch Error:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { loadFiles() }, [])

  return (
    <div className="animate-fade-in">
      <div className="page-header">
        <div>
          <h1 style={{ fontSize: '1.4rem' }}>Media Gallery</h1>
          <p style={{ fontSize: '0.82rem', marginTop: 4 }}>
            Upload images, videos, and documents to Cloudflare R2
          </p>
        </div>
      </div>

      <MediaManager files={files} loading={loading} onRefresh={loadFiles} />
    </div>
  )
}
